<template>
  <div id="app">
    <Navigation />
    <section>
      <SearchBox />
      <router-view />
    </section>
  </div>
</template>

<script>
import Navigation from "./components/Navigation.vue";
import SearchBox from "./components/SearchBox.vue";
// import { initWebSocket } from "./api/ws";

export default {
  components: {
    Navigation,
    SearchBox
  }

  // created() {
  //   initWebSocket("block");
  //   initWebSocket("tx");
  // }
};
</script>

<style lang="scss">
@import url(//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSans-kr.css);
@import "./scss/responsive";
@import "./scss/table";
@import "./scss/contents";
@import "./scss/common";

#app {
  height: 100vh;
  display: flex;
  font-family: $G-font-family;
  color: #333333;
  background-color: #f7f7f7;

  nav {
    flex-shrink: 0;
    min-width: 187px;
  }

  section {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    @include scroll(#f7f7f7);
  }

  h1 {
    margin: 0;
    font-size: 25px;
  }

  a.link {
    font-weight: bold;
    color: #0393f4;
    cursor: pointer;
  }

  button {
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue